import styles from './CollapseButton.module.css'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'

interface CollapseButtonProps{
    onClick: (event: any) => void
}

export const CollapseButton = (props: CollapseButtonProps) => {
    const {
        onClick
    } = props

    const handleCollapseButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button 
            className={styles.CollapseButton}
            onClick={handleCollapseButtonClick}
        >
            <span  className={styles.CollapseButton__IconContainer}>
                <CloseFullscreenIcon 
                    className={styles.CollapseButton__Icon}
                />
            </span>
        </button>
    )
}